import {
    post, get
} from '../networking';
import {
    GetServerSidePropsContext
} from 'next';
import {
    StripeProviderEnum
} from '../utils/payments/types/stripe.type';

export async function getMyCustomer() {
    return await post('payments-gateway/stripe/my-customer');
}

export async function getCustomerShippingAddress(context?: GetServerSidePropsContext, provider = StripeProviderEnum.SUNNYSIDE) {
    const customer = await get(`stripe/customer?provider=${provider}`, {}, context);
    return customer?.shipping || null;
}

import {
    SubscriptionState
} from './subscription-state';

export {
    SubscriptionState
};

export function interpretStripeState(user, subscription?, payment?, customer?): SubscriptionState {
    if(!user) {
        return SubscriptionState.UNKNOWN;
    }

    const subscriptionItem = subscription?.items?.data?.length > 1 ? subscription.items.data.find((item) => item?.plan?.metadata?.['_key'] === 'ss_digital') : subscription;

    if (subscription && (
        (subscription?.plan?.active && subscription?.cancel_at_period_end)
        || (subscriptionItem?.plan?.active && subscription?.cancel_at_period_end)
    )) {
        return SubscriptionState.ACTIVE_DO_NOT_RENEW;
    }

    if(payment && !subscription) {
        return SubscriptionState.CREDIT_CARD_TRIAL;
    }

    if(!subscription) {
        if (customer && customer.metadata && customer.metadata.ms_member) {
            return SubscriptionState.MS_NO_SUBSCRIPTION;
        }
        return SubscriptionState.NO_SUBSCRIPTION;
    }

    if(subscription.status === 'trialing' && !subscription.default_payment_method) {
        return SubscriptionState.NO_CREDIT_CARD_TRIAL;
    } else if (subscription.status === 'trialing' && subscription.default_payment_method) {
        return SubscriptionState.CREDIT_CARD_TRIAL;
    } else if (['incomplete', 'incomplete_expired', 'past_due', 'unpaid'].includes(subscription.status)) {
        return SubscriptionState.ACTIVE_WITH_PAYMENT_ERROR;
    } else if (['canceled'].includes(subscription.status)) {
        return SubscriptionState.CANCELED;
    } else if ((subscription?.plan && subscription?.plan?.active) || (subscriptionItem?.plan && subscriptionItem?.plan?.active)) {
        return SubscriptionState.ACTIVE;
    }
    return SubscriptionState.UNKNOWN;
}
